import SavedCard from './SavedCard'

export default SavedCard
